module.exports = __webpack_public_path__ + "img/icon-vorkasse.c26d6b00.svg";